import  { useState } from "react";
import { awards, slides } from "../../components/Data/datas";

const OurBlog = () => {
  const [activeSection, setActiveSection] = useState("introduction");

  // Table of Contents data
  const tableOfContents = [
    { id: "introduction", title: "Introduction" },
    { id: "problem", title: "The Problem We Aim to Solve" },
    { id: "audience", title: "Target Audience" },
    { id: "vision", title: "Our Vision and Mission" },
    { id: "values", title: "Core Values" },
    { id: "strategy", title: "Our Foundation Strategy" },
    { id: "impact", title: "Global Impact" },
    { id: "languages", title: "Languages of Instruction" },
    { id: "curriculum", title: "What We Teach" },
    { id: "schedule", title: "Program Schedule" },
    { id: "conclusion", title: "Conclusion" },
    { id: "appendix", title: "Appendix" },
  ];

  // Content sections
  const contentSections = {
    introduction: {
      title: "Introduction",
      content: (
        <div className="space-y-6">
          <h3 className="font-medium text-2xl text-gray-800">
            Purpose of this Academy
          </h3>
          <p>
            Learn about Maqraha Ul Tanzeel and our approach to Quranic
            education.
          </p>
          <img
            src={slides[6].image}
            alt="Introduction to Maqraha Ul Tanzeel"
            className="w-full rounded-lg shadow-md"
          />
          <p className="text-gray-700">
            Maqraha Ul Tanzeel represents a comprehensive system for learning
            Quranic recitation with proper tajweed and understanding the various
            authentic methods of recitation.
          </p>

          <h3 className="font-medium text-2xl text-gray-800 mt-8">
            Importance of Learning More Than One Qira'ah
          </h3>
          <p className="text-gray-700">
            Multiple Qira'at provide a deeper understanding of the Quran's
            meanings and preserve the authentic ways the Prophet ﷺ taught
            recitation to his companions.
          </p>
          <img
            src={slides[1].image}
            alt="Learning Multiple Qira'at"
            className="w-full rounded-lg shadow-md mt-4"
          />
        </div>
      ),
    },
    problem: {
      title: "The Problem We Aim to Solve",
      content: (
        <div className="space-y-6">
          <h3 className="font-medium text-2xl text-gray-800">
            Creating a Stress-Free Learning Environment
          </h3>
          <p className="text-gray-700">
            Our academy addresses the challenges many face when trying to learn
            proper Quranic recitation and memorization.
          </p>
          <img
            src={slides[2].image}
            alt="Stress-free learning environment"
            className="w-full rounded-lg shadow-md"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
            <div>
              <h4 className="font-medium text-xl text-gray-800">
                From Certification to Isnād
              </h4>
              <p className="text-gray-700 mt-2">
                We provide students with a personal chain of narration
                connecting them to the Prophet Muhammad ﷺ.
              </p>
              <img
                src={awards[0].image}
                alt="Certification path"
                className="w-full rounded-lg shadow-md mt-4"
              />
            </div>
            <div>
              <h4 className="font-medium text-xl text-gray-800">
                Fulfilling the Obligation
              </h4>
              <p className="text-gray-700 mt-2">
                Proper Quran recitation is a religious obligation we help
                Muslims fulfill with excellence.
              </p>
              <img
                src={awards[1].image}
                alt="Proper recitation"
                className="w-full rounded-lg shadow-md mt-4"
              />
            </div>
          </div>

          <h3 className="font-medium text-2xl text-gray-800 mt-8">
            Quran Memorization Programs
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
            <div>
              <h4 className="font-medium text-xl text-gray-800">
                For Children
              </h4>
              <p className="text-gray-700 mt-2">
                Age-appropriate methods that make memorization engaging and
                effective for young learners.
              </p>
              <img
                src={slides[3].image}
                alt="Children's program"
                className="w-full rounded-lg shadow-md mt-4"
              />
            </div>
            <div>
              <h4 className="font-medium text-xl text-gray-800">For Adults</h4>
              <p className="text-gray-700 mt-2">
                Specialized techniques addressing the unique challenges adult
                learners face with memorization.
              </p>
              <img
                src={slides[4].image}
                alt="Adult program"
                className="w-full rounded-lg shadow-md mt-4"
              />
            </div>
          </div>
        </div>
      ),
    },
    // Additional sections would follow the same pattern
    audience: {
      title: "Target Audience",
      content: (
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-medium text-2xl text-gray-800">
                Huffāẓ (Male & Female)
              </h3>
              <p className="text-gray-700 mt-2">
                Those who have memorized the Quran and seek to master multiple
                recitation styles.
              </p>
              <img
                src={awards[2].image}
                alt="Huffaz students"
                className="w-full rounded-lg shadow-md mt-4"
              />
            </div>
            <div>
              <h3 className="font-medium text-2xl text-gray-800">
                Children Worldwide
              </h3>
              <p className="text-gray-700 mt-2">
                Engaging programs designed specifically for young learners
                across the globe.
              </p>
              <img
                src={slides[5].image}
                alt="Children learning"
                className="w-full rounded-lg shadow-md mt-4"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
            <div>
              <h3 className="font-medium text-2xl text-gray-800">
                International Adults
              </h3>
              <p className="text-gray-700 mt-2">
                Flexible programs accommodating adult learners from diverse
                backgrounds.
              </p>
              <img
                src={awards[3].image}
                alt="International adult students"
                className="w-full rounded-lg shadow-md mt-4"
              />
            </div>
            <div>
              <h3 className="font-medium text-2xl text-gray-800">
                Working-Class Muslims
              </h3>
              <p className="text-gray-700 mt-2">
                Programs designed to fit into busy schedules without
                compromising quality.
              </p>
              <img
                src={slides[6].image}
                alt="Working professionals learning"
                className="w-full rounded-lg shadow-md mt-4"
              />
            </div>
          </div>
        </div>
      ),
    },
    // Remaining sections would be implemented similarly
    vision: {
      title: "Our Vision and Mission",
      content: (
        <div className="space-y-6">
          <h3 className="font-medium text-2xl text-gray-800">
            Vision Statement
          </h3>
          <p className="text-gray-700">
            To be the global leader in Quranic education, preserving and
            spreading authentic recitation worldwide.
          </p>
          <img
            src={slides[0].image}
            alt="Vision illustration"
            className="w-full rounded-lg shadow-md"
          />

          <h3 className="font-medium text-2xl text-gray-800 mt-8">
            Mission Statement
          </h3>
          <p className="text-gray-700">
            To provide accessible, high-quality Quranic education that connects
            students to authentic chains of narration.
          </p>
          <img
            src={slides[1].image}
            alt="Mission illustration"
            className="w-full rounded-lg shadow-md mt-4"
          />

          <h3 className="font-medium text-2xl text-gray-800 mt-8">
            Annual Targets
          </h3>
          <p className="text-gray-700">
            Our measurable goals for student certification and program
            expansion.
          </p>
          <img
            src={awards[0].image}
            alt="Targets illustration"
            className="w-full rounded-lg shadow-md mt-4"
          />
        </div>
      ),
    },
    // Additional sections would be added here
  };

  return (
    <div className="bg-gray-100 py-16 px-4 sm:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Hero Section */}
        <div className="bg-no-repeat bg-center bg-cover relative mb-12 rounded-xl overflow-hidden">
          <img
            src={slides[0].image}
            alt="Academy Blog Header"
            className="w-full h-64 md:h-96 object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center p-8">
            <div className="h-1 w-14 bg-blue-600 mb-6"></div>
            <h1 className="font-bold text-4xl md:text-5xl lg:text-6xl">
              Maqraha Ul Tanzeel
            </h1>
            <p className="mt-4 text-lg md:text-xl max-w-2xl">
              Academy System of Operation
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          {/* Blog Title */}
          <div className="p-8 border-b">
            <h2 className="font-medium text-3xl text-gray-900">Academy Blog</h2>
            <p className="mt-2 text-gray-600">
              Learn about our methodology, programs, and impact
            </p>
          </div>

          <div className="flex flex-col md:flex-row">
            {/* Table of Contents Sidebar */}
            <div className="w-full md:w-1/4 bg-gray-50 p-6 border-r">
              <h3 className="font-medium text-lg text-gray-800 mb-4">
                Table of Contents
              </h3>
              <nav className="space-y-1">
                {tableOfContents.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => setActiveSection(item.id)}
                    className={`block w-full text-left py-2 px-3 rounded-md transition ${
                      activeSection === item.id
                        ? "bg-blue-100 text-blue-700 font-medium"
                        : "text-gray-600 hover:bg-gray-200"
                    }`}
                  >
                    {item.title}
                  </button>
                ))}
              </nav>
            </div>

            {/* Content Area */}
            <div className="w-full md:w-3/4 p-8">
              {contentSections[activeSection] && (
                <>
                  <h2 className="font-bold text-3xl text-gray-900 mb-6">
                    {contentSections[activeSection].title}
                  </h2>
                  <div className="prose max-w-none">
                    {contentSections[activeSection].content}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurBlog;
